import { Container, Title, Text, Stack, Card, Grid, ThemeIcon, Button } from '@mantine/core'
import { IconPhone, IconMail, IconMapPin, IconClock } from '@tabler/icons-react'

export function ContactPage() {
  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <Title order={1} ta="center" mb="md">
          Контакты
        </Title>
        
        <Text size="lg" ta="center" c="dimmed" maw={800} mx="auto">
          Свяжитесь с нами любым удобным способом
        </Text>

        <Grid mt="xl">
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <ThemeIcon size="xl" radius="md" variant="gradient" gradient={{ from: 'green', to: 'teal' }} mb="md">
                <IconPhone size="2rem" />
              </ThemeIcon>
              <Title order={3} mb="sm">Телефон</Title>
              <Text c="dimmed" mb="md">
                +7 (999) 123-45-67
              </Text>
              <Text size="sm" c="dimmed">
                Звонок бесплатный
              </Text>
            </Card>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <ThemeIcon size="xl" radius="md" variant="gradient" gradient={{ from: 'blue', to: 'cyan' }} mb="md">
                <IconMail size="2rem" />
              </ThemeIcon>
              <Title order={3} mb="sm">Email</Title>
              <Text c="dimmed" mb="md">
                info@autoexpert.ru
              </Text>
              <Text size="sm" c="dimmed">
                Ответим в течение часа
              </Text>
            </Card>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <ThemeIcon size="xl" radius="md" variant="gradient" gradient={{ from: 'orange', to: 'red' }} mb="md">
                <IconMapPin size="2rem" />
              </ThemeIcon>
              <Title order={3} mb="sm">Адрес</Title>
              <Text c="dimmed" mb="md">
                г. Москва, ул. Автомобильная, д. 123
              </Text>
              <Text size="sm" c="dimmed">
                Рядом с метро
              </Text>
            </Card>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <ThemeIcon size="xl" radius="md" variant="gradient" gradient={{ from: 'violet', to: 'grape' }} mb="md">
                <IconClock size="2rem" />
              </ThemeIcon>
              <Title order={3} mb="sm">Время работы</Title>
              <Text c="dimmed" mb="md">
                Пн-Пт: 8:00 - 20:00
              </Text>
              <Text size="sm" c="dimmed">
                Сб-Вс: 9:00 - 18:00
              </Text>
            </Card>
          </Grid.Col>
        </Grid>

        <Card shadow="sm" padding="xl" radius="md" withBorder style={{ textAlign: 'center' }}>
          <Title order={2} mb="md">Записаться на ремонт</Title>
          <Text c="dimmed" mb="xl">
            Оставьте заявку и мы свяжемся с вами в ближайшее время
          </Text>
          <Button size="lg" leftSection={<IconPhone size="1rem" />}>
            Позвонить сейчас
          </Button>
        </Card>
      </Stack>
    </Container>
  )
}